import { useEffect, useState } from "react";

import { Typography, TextField, Button } from "@king-ict/eupisi-ui/components";
import { ReactComponent as AddIcon } from "@king-ict/eupisi-ui/components/Icon/Add.svg";
import { ReactComponent as RemoveIcon } from "@king-ict/eupisi-ui/components/Icon/RemoveIcon.svg";
import { Col, Row } from "react-bootstrap";

import styles from "./OtherData.module.scss";

export interface OtherDataProps {
    name: string;
    header: string;
    label: string;
    addButtonLabel: string;
    values: string[];
    readonly?: boolean;
    isCorrection?: boolean;
    getErrorForPath: (path: string) => string | undefined;
    onChange: (e: any) => void;
}

export default function OtherData({
    name,
    header,
    label,
    addButtonLabel,
    values,
    readonly = false,
    isCorrection = false,
    getErrorForPath,
    onChange
}: OtherDataProps) {

    const [labelValues, setLabelValues] = useState<string[]>([]);

    useEffect(() => {
        if (isCorrection) {
            var copyValues = JSON.parse(JSON.stringify(values));
            setLabelValues(copyValues);
        }
    }, [])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        var newList = values.slice();
        newList[index] = event.target.value;

        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: newList
            }
        });
    };

    const handleAdd = (event: React.MouseEvent<any, MouseEvent>) => {
        var newList = values.slice();
        newList.push("");
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: newList
            }
        });
    };

    const handleRemove = (event: React.MouseEvent<any, MouseEvent>, index: number) => {
        var newList = values.slice();
        newList.splice(index, 1);
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: newList
            }
        });
    };

    return (
        <>
            {!isCorrection &&
                <Row>
                    <Col md={12} className={styles.rowTitleSpacing}>
                        <Typography variant="smallHeading" component="h3">
                            {header}
                        </Typography>
                    </Col>
                </Row>
            }
            <Row className={styles.rowSpacing}>
                {values.map((value, index) => (
                    <Col md={12}>
                        <Row>
                            <Col md={12} className={styles.otherValueFieldRow}>
                                <div className={styles.otherValueTextField}>
                                    <TextField
                                        label={isCorrection ? labelValues[index] : label}
                                        value={value}
                                        maxLength={512}
                                        onChange={(e) => handleChange(e, index)}
                                        plaintext={readonly}
                                        errorText={getErrorForPath(`${name}${index}`)}
                                    />
                                </div>
                                {!readonly &&
                                    <div className={styles.otherValueRemoveField}>
                                        <Button
                                            boxless
                                            onClick={(e) => handleRemove(e, index)}
                                            disabled={values.length <= 1}
                                        >
                                            <RemoveIcon />
                                        </Button>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </Col>
                ))}
            </Row>
            {!readonly &&
                <Row className={styles.addDataButtonCol}>
                    <Col md={12}>
                        <Button
                            disabled={values.length >= 10}
                            outline
                            icon={<AddIcon />}
                            onClick={handleAdd}
                        >
                            {addButtonLabel}
                        </Button>
                    </Col>
                </Row>
}
        </>
    );
}